import { renderSiteGlueChannelsComment } from "~/lib/siteglue/business-ready/agent-channels";

/**
 * Single production embed script: `/w.js?id=PROJECT_ID`
 * No separate "v2" URL and no `&v=` cache-bust — `next.config.mjs` sets no-cache on `/w.js`.
 */
export function buildWjsEmbedScriptUrl(
  origin: string,
  projectId: string,
  opts?: { variantB?: boolean; reloadKey?: number; defer?: boolean; builderPreview?: boolean; toolsOnly?: boolean },
): string {
  const base = origin.replace(/\/$/, "");
  const params = new URLSearchParams({ id: projectId });
  if (opts?.variantB) params.set("variantB", "1");
  if (opts?.builderPreview) params.set("builderPreview", "1");
  if (opts?.defer) params.set("defer", "1");
  if (opts?.toolsOnly) params.set("toolsOnly", "1");
  if (opts?.reloadKey != null && opts.reloadKey > 0) {
    params.set("_k", String(opts.reloadKey));
  }
  return `${base}/w.js?${params.toString()}`;
}

/** Head links a customer site pastes with the widget so agents can find the MCP server. */
export const AGENT_DISCOVERY_SNIPPET = `<link rel="mcp" type="application/json" href="/.well-known/mcp.json" />
<link rel="alternate" type="text/plain" href="/llms.txt" title="llms.txt" />`;

/** Full embed for a customer site, including MCP discovery links. */
export function buildWjsEmbedScriptTag(
  origin: string,
  projectId: string,
  opts?: { defer?: boolean; variantB?: boolean; toolsOnly?: boolean; channels?: readonly string[] },
): string {
  const channels = opts?.channels?.length ? opts.channels : ["website"];
  return `${renderSiteGlueChannelsComment(channels)}
${AGENT_DISCOVERY_SNIPPET}
<script src="${buildWjsEmbedScriptUrl(origin, projectId, {
    defer: opts?.defer,
    variantB: opts?.variantB,
    toolsOnly: opts?.toolsOnly,
  })}"></script>`;
}
